import { DATE_FORMATS } from 'constants/dateFormats';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(calendar);
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = ({
  date,
  format = DATE_FORMATS.SHORT,
  fallback = 'N/A'
}) => {
  return date ? dayjs(date).format(format) : fallback;
};

export const calendarDate = (date) => {
  if (!date) return 'N/A';

  return dayjs(date).calendar(null, {
    sameDay: '[today] [at] h:mma',
    lastDay: '[yesterday] [at] h:mma',
    lastWeek: '[on] MM/DD/YYYY',
    sameElse: '[on] MM/DD/YYYY',
    nextDay: '[tomorrow] [at] h:mma',
    nextWeek: '[on] MM/DD/YYYY'
  });
};

export const parseShortDateString = ({ date }) => {
  // Returns the parsed dayjs object, or null if no string was provided
  return date ? dayjs(date, DATE_FORMATS.SHORT) : null;
};

export const isPastDue = ({ date }) => {
  // If there is no due date, it technically can't be overdue
  return date ? dayjs().isAfter(date) : false;
};

export const parseDate = ({ date }) => {
  // Returns a dayjs object if the date exists, otherwise returns null
  // to prevent accidental current-date generation (which dayjs() does by default)
  return date ? dayjs(date) : null;
};

export const formatRelativeTime = ({ date }) => {
  return date ? dayjs(date).fromNow() : '';
};

export const convertDaysToMilliseconds = ({ days }) => {
  return days * 24 * 60 * 60 * 1000;
};
